import React from 'react';
import type { DatasetGenerationPredictTokenUsageResponse } from '../../types/datasetGenerationPreview';
import { formatPredictedCostUsd, getPredictedCostUsd, pricingModelTooltip } from '../../utils/previewCost';
import LazyDetails from '../EvaluationRunModal/LazyDetails';
import './DatasetGenerationTokenPreviewView.css';

function formatNumber(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '—';
  return value.toLocaleString();
}

function MetricCard({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="preview-result-card">
      <div className="preview-result-card-label">{label}</div>
      <div className="preview-result-card-value">{value}</div>
    </div>
  );
}

export default function DatasetGenerationTokenPreviewView({
  data,
}: {
  data: DatasetGenerationPredictTokenUsageResponse;
}) {
  const features =
    data.features && typeof data.features === 'object' ? Object.entries(data.features) : [];
  const predictedCost = getPredictedCostUsd(data.predicted_total_cost_usd);
  const pricingTooltip = pricingModelTooltip(data.pricing_model_name);

  return (
    <div className="optimization-preview-result dataset-gen-token-preview">
      <div className="preview-result-cards">
        <MetricCard
          label="Predicted cost"
          value={
            <span title={pricingTooltip} className="preview-result-card-value--cost">
              {formatPredictedCostUsd(predictedCost)}
            </span>
          }
        />
        <MetricCard label="Expected input tokens" value={formatNumber(data.expected_input_tokens)} />
        <MetricCard label="Expected output tokens" value={formatNumber(data.expected_output_tokens)} />
        <MetricCard label="Expected total tokens" value={formatNumber(data.expected_total_tokens)} />
      </div>

      {features.length > 0 ? (
        <LazyDetails
          className="eval-run-result__details dataset-gen-token-preview__features"
          summary="Prediction features"
        >
          <dl className="dataset-gen-token-preview__feature-list">
            {features.map(([key, value]) => (
              <div key={key} className="dataset-gen-token-preview__feature-row">
                <dt>{key.replace(/_/g, ' ')}</dt>
                <dd>{typeof value === 'number' ? formatNumber(value) : String(value ?? '—')}</dd>
              </div>
            ))}
          </dl>
        </LazyDetails>
      ) : null}
    </div>
  );
}
